import React from "react";
import View from "../components/View";
import { useParams } from "react-router-dom";

import { Container } from "react-bootstrap";
import PairAddressContext from "../contexts/PairAddress";
import LendingPoolPage from "../components/LendingPoolPage";
import FactoryContext from "../contexts/Factory";
import { Address, Factory } from "impermax-sdk";

/**
 * LendingPool page view.
 */
export default function LendingPool() {
  const { factory, pairAddress } = useParams<{
    factory: Factory;
    pairAddress: Address;
  }>();

  //const doUpdate = useDoUpdate();
  //useInterval(() => doUpdate(), 60000);

  return (
    <View>
      <Container className="lending-pool">
        <FactoryContext.Provider value={factory}>
          <PairAddressContext.Provider value={pairAddress}>
            <LendingPoolPage />
          </PairAddressContext.Provider>
        </FactoryContext.Provider>
      </Container>
    </View>
  );
}
